import type {CourseModel} from '../../../domain/Course/Course.model';
import type {DateTimeModel} from '../../../domain/Date/DateTime.model';

export abstract class CreateCourseCmd {
  abstract exec(
    props: CreateCourseCmd.Props,
  ): Promise<CreateCourseCmd.Response>;
}

export namespace CreateCourseCmd {
  export type Props = {
    label?: string;
    programId: string;
    startDate: DateTimeModel;
  };
  export type Response = CourseModel;
}
